import * as HLF from "html-living-framework";
import { GalleryPaintableData } from "../Data/GalleryPaintableData";
import { IOnboardingTarget } from "../GameObjects/IOnboardingTarget";
import { PaintableLayer } from "../GameObjects/PaintableLayer";

export abstract class Paintable extends PIXI.Container implements IOnboardingTarget {
    protected _index: number;
    protected _layers: PaintableLayer[];
    protected _sequence: number[];

    constructor(pIndex: number) {
        super();
        this._index = pIndex;
        this._layers = new Array<PaintableLayer>();
        this._sequence = new Array<number>();
    }

    public set activeColor(pValue: number) {
        for (let i = 0; i < this._layers.length; ++i) {
            this._layers[i].paletteColour = pValue;
        }
    }

    public get layers(): PaintableLayer[] {
        return this._layers;
    }

    public onLayerPainted(pIndex: number): void {
        const existing: number = this._sequence.indexOf(pIndex);
        if (existing !== -1) {
            this._sequence.splice(existing, 1);
        }
        if (this._layers[pIndex].paintedColour !== 0xFFFFFF) {
            this._sequence.push(pIndex);
        }
    }

    public paintLayer(pIndex: number, pColour: number, pInstantly: boolean = false): void {
        pIndex = HLF.MathUtils.clamp(pIndex, 0, this._layers.length);
        this._layers[pIndex].paint(pColour, undefined, undefined, pInstantly);
    }

    public setInputEnabled(pEnable: boolean): void {
        for (let i = 0; i < this._layers.length; ++i) {
            this._layers[i].setInputEnabled(pEnable);
        }
        PubSub.publishSync(pEnable ? HLF.REGISTER_FOCUSABLES : HLF.UNREGISTER_FOCUSABLES, this._layers);
        PubSub.publishSync(HLF.RE_MAP_KEYBOARD, undefined);
    }

    public clear(): void {
        for (let i = 0; i < this._layers.length; ++i) {
            this._layers[i].paint(0xFFFFFF, 0.5, 0.5, false, true, false, true);
        }
    }

    public getOnboardingPosition(): PIXI.Point {
        const offset: PIXI.Point = new PIXI.Point(225, -175);
        const local: PIXI.Point = HLF.PointUtils.add(this.position, offset);
        return this.transform.worldTransform.apply(local);
    }

    public getOnboardingRotation(): number {
        return Math.PI * 0.5;
    }

    public generateSaveData(): GalleryPaintableData {
        const colours: number[] = new Array<number>();
        for (let i = 0; i < this._layers.length; ++i) {
            colours.push(this._layers[i].paintedColour);
        }
        return new GalleryPaintableData(this._sequence, colours);
    }
}
